export {
  PIXEL_PERSON_GRID_WIDTH,
  PIXEL_PERSON_GRID_HEIGHT,
  PIXEL_PERSON_VIEWBOX_PAD_TOP,
  PIXEL_PERSON_VIEWBOX_PAD_BOTTOM,
  PIXEL_PERSON_VIEWBOX_HEIGHT,
} from './pixelPersonGridDimensions';

export {
  PIXEL_PERSON_HAIR_STYLE_IDS,
  PIXEL_PERSON_BODY_GRID,
  PIXEL_PERSON_HAIR_STYLE_GRIDS,
  mergePixelPersonGrid,
  buildPixelPersonGrid,
} from './pixelPersonHairStyles';

import { buildPixelPersonGrid } from './pixelPersonHairStyles';

/** Default bob hairstyle grid. */
export const PIXEL_PERSON_GRID = buildPixelPersonGrid('bob');
